// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"79e5ad8d","716":"98a04475","874":"d8881dbd"}[chunkId] + ".chunk.js";
};